import { Filters } from "./filters";
import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const PotentialRepeatReportConfig: ReportConfigBase = {
  type: EReportTypes.PotentialRepeat,
  endpoint: "report/potential-repeat",
  filtersBase: Filters,
  summaryBase: null,
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "Identify repeat projects from past activity and find high-potential sales. Use filters like custom date range and budget to focus, and take action by creating new tasks and projects.",
    url: "https://help.commonsku.com/knowledge/potential-repeat-order-report",
  },
};

export default PotentialRepeatReportConfig;
